import { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import { Note, Panel } from '../../ui/basics';
import { useToast } from '../../ui/Toast';

export function ExportPage() {
  const toast = useToast();
  const [token, setToken] = useState<string | null>(null);
  const start = useMutation({
    mutationFn: () => api.post<{ token: string }>('/export/full'),
    onSuccess: (r) => setToken(r.token),
    onError: (e: Error) => toast(e.message, 'error'),
  });
  const status = useQuery({
    queryKey: ['export', token],
    queryFn: () => api.get<{ status: string; error?: string; file: string | null }>(`/export/full/${token}`),
    enabled: Boolean(token),
    refetchInterval: (q) => (q.state.data?.status === 'running' ? 2000 : false),
  });
  const list = useQuery({ queryKey: ['exports'], queryFn: () => api.get<{ items: string[] }>('/export/list').then((r) => r.items) });
  useEffect(() => {
    if (status.data?.status === 'done') list.refetch();
  }, [status.data?.status]);
  return (
    <>
      <Note kind="info">Vollständiger Export aller Daten und Dateien als Archiv. Zusätzlich wird jede Nacht automatisch gesichert.</Note>
      <Panel title="Export erzeugen">
        <div className="pb">
          <button className="btn primary" type="button" onClick={() => start.mutate()} disabled={start.isPending || status.data?.status === 'running'}>
            Vollexport starten
          </button>
          {status.data && (
            <div className="mt-12">
              {status.data.status === 'running' && <span className="mut">Export läuft …</span>}
              {status.data.status === 'failed' && <span className="miss">Fehlgeschlagen: {status.data.error}</span>}
              {status.data.status === 'done' && (
                <a className="btn" href={`/api/v1/export/full/${token}?download=1`}>
                  {status.data.file} herunterladen
                </a>
              )}
            </div>
          )}
        </div>
      </Panel>
      <Panel title="Bisherige Exporte">
        {list.data?.length ? (
          <ul className="list">
            {list.data.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        ) : (
          <div className="empty">Noch kein Export</div>
        )}
      </Panel>
    </>
  );
}
